import httpContext from '@rover/rsdk/src/modules/Network/httpContext';

export const getCountryUrlPrefixFromExpress = (): string => {
  if (process.env.JS_ENV_SERVER) {
    const req = httpContext.getReq();
    const possibleCountryParam = req?.params?.['0']?.replace('/', '');

    if (possibleCountryParam?.length === 2) {
      return possibleCountryParam;
    }
  }

  return '';
};
